// import { resolve } from 'path'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: (resolve) => {
        import('./views/Login').then((module) => {
          resolve(module)
        })
      },
    },
    {
      path: '/',
      name: '/',
      // component: App,
      redirect: '/home',
      children: [],
    },
    {
      path: '/home',
      meta: { requiresAuth: true, keepAlive: true },
      component: (resolve) => {
        import('./views/Home').then((module) => {
          resolve(module)
        })
      },
      // redirect: '/actor/FlowList',
      children: [
        {
          path: '/hostmgr/HostVestInfo',
          component: (resolve) => {
            import('./views/hostmgr/HostVestInfo_new').then((module) => {
              resolve(module)
            })
          },
          name: 'hostmgr/HostVestInfo',
          meta: {
            requiresAuth: true,
            title: '马甲信息',
            keepAlive: true,
          },
        },
        {
          path: '/callcount/CallData',
          component: (resolve) => {
            import('./views/callcount/CallData').then((module) => {
              resolve(module)
            })
          },
          name: 'callcount/CallData',
          meta: {
            requiresAuth: true,
            title: '视频通话',
            keepAlive: true,
          },
        },
        {
          path: '/callcount/SuccessRate',
          component: (resolve) => {
            import('./views/callcount/SuccessRate').then((module) => {
              resolve(module)
            })
          },
          name: 'callcount/SuccessRate',
          meta: {
            requiresAuth: true,
            title: '通话成功率',
          },
        },
        {
          path: '/fnc/Gold',
          component: (reslove) => {
            import('./views/fnc/Gold').then((module) => {
              reslove(module)
            })
          },
          name: '/fnc/Gold',
          meta: {
            requiresAuth: true,
            title: '金币',
          },
        },
        {
          path: '/fnc/Subscribe',
          component: (reslove) => {
            import('./views/fnc/Subscribe').then((module) => {
              reslove(module)
            })
          },
          name: '/fnc/Subscribe',
          meta: {
            requiresAuth: true,
            title: '订阅',
          },
        },
        {
          path: '/callcount/ReasonForHangingUp',
          component: (reslove) => {
            import('./views/callcount/ReasonForHangingUp').then((module) => {
              reslove(module)
            })
          },
          name: '/callcount/ReasonForHangingUp',
          meta: {
            requiresAuth: true,
            title: '通话挂断原因',
          },
        },
        {
          path: '/fncnew/NewActor_NewVIP',
          component: (reslove) => {
            import('./views/fncnew/NewActor_NewVIP').then((module) => {
              reslove(module)
            })
          },
          name: 'fncnew/NewActor_NewVIP',
          meta: {
            requiresAuth: true,
            title: '新增用户与VIP',
          },
        },
        {
          path: '/fnc/Recharge',
          component: (reslove) => {
            import('./views/fnc/Recharge').then((module) => {
              reslove(module)
            })
          },
          name: 'fnc/Recharge',
          meta: {
            requiresAuth: true,
            title: '用户充值',
          },
        },
        {
          path: '/actor/LifeCycle',
          component: (reslove) => {
            import('./views/actor/LifeCycle').then((module) => {
              reslove(module)
            })
          },
          name: '/actor/LifeCycle',
          meta: {
            requiresAuth: true,
            title: '用户生命周期监控',
          },
        },
        {
          path: '/patrol/search',
          component: (reslove) => {
            import('./views/actor/PatrolSearch').then((module) => {
              reslove(module)
            })
          },
          name: 'patrol_search',
          meta: {
            requiresAuth: true,
            title: '视频巡查',
          },
        },
        {
          path: '/recommended_video/list',
          component: (reslove) => {
            import('./views/actor/RecommendedVideo').then((module) => {
              reslove(module)
            })
          },
          name: 'recommended_video',
          meta: {
            requiresAuth: true,
            title: '视频推荐',
          },
        },
        {
          path: '/video/patrol',
          component: (reslove) => {
            import('./views/actor/PatrolSearch').then((module) => {
              reslove(module)
            })
          },
          name: 'video_patrol',
          meta: {
            requiresAuth: true,
            title: '视频巡查',
          },
        },
        {
          path: '/video/offline/match',
          component: (reslove) => {
            import('./views/video/offline/Match').then((module) => {
              reslove(module)
            })
          },
          name: 'video_offline_match',
          meta: {
            requiresAuth: true,
            title: '主播离线视频-匹配',
          },
        },
        {
          path: '/video/offline/chat',
          component: (reslove) => {
            import('./views/video/offline/Chat').then((module) => {
              reslove(module)
            })
          },
          name: 'video_offline_chat',
          meta: {
            requiresAuth: true,
            title: '主播离线视频-通话',
          },
        },
        {
          path: '/video/ai/match',
          component: (reslove) => {
            import('./views/video/ai/Match').then((module) => {
              reslove(module)
            })
          },
          name: 'video_ai_match',
          meta: {
            requiresAuth: true,
            title: 'AI电话-匹配',
          },
        },
        {
          path: '/video/ai/chat',
          component: (reslove) => {
            import('./views/video/ai/Chat').then((module) => {
              reslove(module)
            })
          },
          name: 'video_ai_chat',
          meta: {
            requiresAuth: true,
            title: 'AI电话-通话',
          },
        },
        {
          path: '/actormgr/UsersInfo',
          name: 'actormgr_users_info',
          meta: {
            requiresAuth: true,
            title: '用户信息管理',
          },
          component: (resolve) => {
            import('./views/actormgr/UsersInfo').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actormgr/ActorList',
          name: '/actormgr/ActorList',
          meta: {
            requiresAuth: true,
            title: '用户信息',
          },
          component: (resolve) => {
            import('./views/actormgr/ActorList').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actormgr/LevelUp',
          name: 'actormgr_levelup',
          meta: {
            requiresAuth: true,
            title: '用户升级管理',
            keepAlive: true,
          },
          component: (resolve) => {
            import('./views/actormgr/LevelUp/index.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actormgr/Online',
          name: 'user_online_page',
          meta: {
            requiresAuth: true,
            title: '在线信息',
          },
          component: (resolve) => {
            import('./views/actormgr/Online').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actormgr/phone_code',
          name: 'actormgr_phone_code',
          meta: {
            requiresAuth: true,
            title: '手机验证码查询',
          },
          component: (resolve) => {
            import('./views/actormgr/PhoneCode').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/HostList',
          name: '',
          meta: {
            requiresAuth: true,
            title: '查看报表',
          },
          component: (resolve) => {
            import('./views/host/HostList').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/income_detail',
          name: '',
          meta: {
            requiresAuth: true,
            title: '查看报表',
          },
          component: (resolve) => {
            import('./views/host/income_detail').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/gradeHostRetain',
          name: '',
          meta: {
            requiresAuth: true,
            title: '查看报表',
          },
          component: (resolve) => {
            import('./views/host/gradeHostRetain').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/RealTimeData',
          name: '',
          meta: {
            requiresAuth: true,
            title: '查看报表',
          },
          component: (resolve) => {
            import('./views/host/RealTimeData').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/TrialHostPool',
          name: '',
          meta: {
            requiresAuth: true,
            title: '查看报表',
          },
          component: (resolve) => {
            import('./views/host/TrialHostPool').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/QualityHostPool',
          name: '',
          meta: {
            requiresAuth: true,
            title: '查看报表',
          },
          component: (resolve) => {
            import('./views/host/QualityHostPool').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/Exposure',
          name: '',
          meta: {
            requiresAuth: true,
            title: '查看报表',
          },
          component: (resolve) => {
            import('./views/host/Exposure').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actor/BasicFlow',
          name: '',
          meta: {
            requiresAuth: true,
            title: '基础流量报表',
          },
          component: (resolve) => {
            import('./views/actor/BasicFlow').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/users/signIn',
          name: '',
          meta: {
            requiresAuth: true,
            title: '签到数据报表',
          },
          component: (resolve) => {
            import('./views/actor/user/signIn').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/users/smashEgg',
          name: '',
          meta: {
            requiresAuth: true,
            title: '砸蛋数据报表',
          },
          component: (resolve) => {
            import('./views/actor/user/smashEgg').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/users/slotMachine',
          name: 'report_client_slotMachine',
          meta: {
            requiresAuth: true,
            title: '老虎机数据报表',
          },
          component: (resolve) => {
            import('./views/actor/user/slotMachine').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/matchCard/receive',
          name: 'report_receive',
          meta: {
            requiresAuth: true,
            title: '匹配卡领取数据',
          },
          component: (resolve) => {
            import('./views/actor/matchCard/receive').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/matchCard/consume',
          name: 'report_consume',
          meta: {
            requiresAuth: true,
            title: '匹配卡消耗数据',
          },
          component: (resolve) => {
            import('./views/actor/matchCard/consume').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/matchCard/recharge',
          name: 'report_recharge',
          meta: {
            requiresAuth: true,
            title: '匹配卡转化效果数据报表',
          },
          component: (resolve) => {
            import('./views/actor/matchCard/recharge').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/client/Logs',
          name: 'report_client_single_log_page',
          meta: {
            requiresAuth: true,
            title: '客户端日志',
          },
          component: (resolve) => {
            import('./views/dev/client/Logs').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fnc/Revenue',
          name: 'report_income_page',
          meta: {
            requiresAuth: true,
            title: '基础营收报表',
          },
          component: (resolve) => {
            import('./views/fnc/Revenue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fnc/SubscribeData',
          name: 'report_subscription_page',
          meta: {
            requiresAuth: true,
            title: '订阅数据',
          },
          component: (resolve) => {
            import('./views/fnc/SubscribeData').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/Appraisal',
          name: 'report_evaluate_page',
          meta: {
            requiresAuth: true,
            title: '主播评价',
          },
          component: (resolve) => {
            import('./views/host/Appraisal').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fncnew/Top-upDistribution',
          name: 'report_pay_report',
          meta: {
            requiresAuth: true,
            title: '新用户充值分布报表',
          },
          component: (resolve) => {
            import('./views/fncnew/Top-upDistribution').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/CallExposure',
          name: 'report_exposure',
          meta: {
            requiresAuth: true,
            title: '主播通话曝光',
          },
          component: (resolve) => {
            import('./views/host/CallExposure').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fncnew/Repurchase',
          name: 'report_repurchase',
          meta: {
            requiresAuth: true,
            title: '用户复购',
          },
          component: (resolve) => {
            import('./views/fncnew/Repurchase').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fnc/RechargeData',
          name: 'user_repurchase',
          meta: {
            requiresAuth: true,
            title: '用户充值数据列表',
          },
          component: (resolve) => {
            import('./views/fnc/RechargeData').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fnc/ActorRepurchaseCycle',
          name: 'fnc_ActorRepurchaseCycle',
          meta: {
            requiresAuth: true,
            title: '用户充值数据列表',
          },
          component: (resolve) => {
            import('./views/fnc/ActorRepurchaseCycle').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fnc/ARPU',
          name: 'ARPU',
          meta: {
            requiresAuth: true,
            title: '用户充值数据列表',
          },
          component: (resolve) => {
            import('./views/fnc/ARPU').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fnc/ad_cost',
          name: 'Adconst',
          meta: {
            requiresAuth: true,
            title: '推广成本列表',
          },
          component: (resolve) => {
            import('./views/fnc/Adcost').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/fnc/promotion_cost',
          name: 'promotion_cost',
          meta: {
            requiresAuth: true,
            title: '推广成本导入(按国家细分)',
          },
          component: (resolve) => {
            import('./views/fnc/promotion_cost').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/report/rechargeSource',
          name: 'rechargeSource',
          meta: {
            requiresAuth: true,
            title: '用户充值数据列表',
          },
          component: (resolve) => {
            import('./views/fnc/report/rechargeSource').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/report/newRechargeSource',
          name: 'newRechargeSource',
          meta: {
            requiresAuth: true,
            title: '用户充值数据列表',
          },
          component: (resolve) => {
            import('./views/fnc/report/newRechargeSource').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/report/firstRecharge',
          meta: {
            requiresAuth: true,
            title: '首充用户留存/复购表',
          },
          component: (resolve) => {
            import('./views/fnc/report/firstRecharge').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/ActorCall',
          meta: {
            requiresAuth: true,
            title: '用户拨打主播列表',
          },
          component: (resolve) => {
            import('./views/host/ActorCall').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/Match',
          meta: {
            requiresAuth: true,
            title: '主播匹配通话',
          },
          component: (resolve) => {
            import('./views/host/Match').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/ActiveCall',
          meta: {
            requiresAuth: true,
            title: '主播主动拨打',
          },
          component: (resolve) => {
            import('./views/host/ActiveCall').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/user/password/Update',
          name: 'managers_modify_password_page',
          meta: {
            requiresAuth: true,
            title: '修改密码',
          },
          component: (resolve) => {
            import('./views/user/password/Update').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/server/Status',
          name: 'servers_server_page',
          meta: {
            requiresAuth: true,
            title: '服务器状态',
          },
          component: (resolve) => {
            import('./views/dev/server/Status').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/monitor/index',
          name: 'give_index',
          meta: {
            requiresAuth: true,
            title: '告警列表',
          },
          component: (resolve) => {
            import('./views/dev/monitor/Index').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/aws_s3/Manager',
          name: 'give_Manager',
          meta: {
            requiresAuth: true,
            title: '告警列表',
          },
          component: (resolve) => {
            import('./views/dev/aws_s3/Manager').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/channel/Update',
          name: 'operations_app_update',
          meta: {
            requiresAuth: true,
            title: '渠道更新',
          },
          component: (resolve) => {
            import('./views/dev/channel/Update').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actormgr/BlockLog',
          name: 'exploit_blockedLogs',
          meta: {
            requiresAuth: true,
            title: '封禁日志',
          },
          component: (resolve) => {
            import('./views/actormgr/BlockLog').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actor/FlowList',
          name: '',
          meta: {
            requiresAuth: true,
            title: '获取用户流量总览数据',
          },
          component: (resolve) => {
            import('./views/actor/FlowList').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/FlowList',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/host/FlowList').then((module) => {
              resolve(module)
            })
          },
        },

        {
          path: '/dev/items/List',
          name: 'dev_items_list',
          meta: {
            requiresAuth: true,
            title: '',
          },
          component: (resolve) => {
            import('./views/actor/List').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/money_operator',
          name: 'dev_money_operator',
          meta: {
            requiresAuth: true,
            title: '',
          },
          component: (resolve) => {
            import('./views/dev/money_operator').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/money_operator_read',
          name: 'dev_money_operator_read',
          meta: {
            requiresAuth: true,
            title: '',
          },
          component: (resolve) => {
            import('./views/dev/money_operator_onlyRead').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/gateway',
          name: 'gateway',
          meta: {
            requiresAuth: true,
            title: '',
          },
          component: (resolve) => {
            import('./views/dev/gateway').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/dev/actor/Update',
          name: 'Update',
          meta: {
            requiresAuth: true,
            title: '',
          },
          component: (resolve) => {
            import('./views/actor/Update').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actor/TotalList',
          name: '_totle',
          meta: {
            requiresAuth: true,
            title: '用户总览数据',
          },
          component: (resolve) => {
            import('./views/actor/TotalList').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actor/ActiveCall',
          name: 'active_source',
          meta: {
            requiresAuth: true,
            title: '有效通话来源',
          },
          component: (resolve) => {
            import('./views/actor/ActiveCall').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/CallMatch',
          name: 'chat_match',
          meta: {
            requiresAuth: true,
            title: '通话匹配',
          },
          component: (resolve) => {
            import('./views/host/CallMatch').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/IntroduceUsers',
          name: 'IntroduceUsers',
          meta: {
            requiresAuth: true,
            title: '主播引入用户明细',
          },
          component: (resolve) => {
            import('./views/host/IntroduceUsers').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/GuaranteePool',
          name: 'GuaranteePool',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/host/GuaranteePool').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actor/Retention',
          name: 'actor_retention',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/actor/Retention').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/actormgr/sender',
          name: 'actormgr_sender',
          meta: {
            requiresAuth: true,
            title: 'actormgr_sender',
          },
          component: (resolve) => {
            import('./views/actormgr/sender').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/video_monitor',
          name: 'video_monitor',
          meta: {
            requiresAuth: true,
            title: '用户视频通话监控',
          },
          component: (resolve) => {
            import('./views/actormgr/videoCallSurveillance').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/Activity_PK',
          name: 'activity_pk',
          meta: {
            requiresAuth: true,
            title: 'pk活动配置',
          },
          component: (resolve) => {
            import('./views/official/ActivityPk').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/Bomb',
          name: 'bomb',
          meta: {
            requiresAuth: true,
            title: '弹窗管理',
          },
          component: (resolve) => {
            import('./views/official/bomb').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/video',
          name: 'video',
          meta: {
            requiresAuth: true,
            title: '查看用户视频通话监控',
          },
          component: (resolve) => {
            import('./views/actormgr/video').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/feedback',
          name: 'feedback',
          meta: {
            requiresAuth: true,
            title: '反馈',
          },
          component: (resolve) => {
            import('./views/official/feedback').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/emoji',
          name: 'emoji',
          meta: {
            requiresAuth: true,
            title: '表情包管理',
          },
          component: (resolve) => {
            import('./views/official/emoji').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/room_rocket',
          name: 'room_rocket',
          meta: {
            requiresAuth: true,
            title: '房间火箭管理',
          },
          component: (resolve) => {
            import('./views/official/roomRocket').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/zone_config',
          name: 'zone_config',
          meta: {
            requiresAuth: true,
            title: '分区配置',
          },
          component: (resolve) => {
            import('./views/official/zone_config').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/room_list_tab_config',
          name: 'room_list_tab_config',
          meta: {
            requiresAuth: true,
            title: '房间列表tab配置',
          },
          component: (resolve) => {
            import('./views/official/room_tab_config').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/risk',
          name: 'official_risk_refund',
          meta: {
            requiresAuth: true,
            title: '退款风控配置',
          },
          component: (resolve) => {
            import('./views/official/Risk/index').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/feedback/scoreFeedback',
          name: 'score_feedback',
          meta: {
            requiresAuth: true,
            title: '评分反馈',
          },
          component: (resolve) => {
            import('./views/official/ScoreFeedback').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/official/event/gala',
          name: 'official_event_gala',
          meta: {
            requiresAuth: true,
            title: '庆典房活动配置',
          },
          component: (resolve) => {
            import('./views/official/gala').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offcial/game_bd',
          name: 'game_bd',
          meta: {
            requiresAuth: true,
            title: '游戏BD',
          },
          component: (resolve) => {
            import('./views/official/game_bd').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/report',
          name: 'report',
          meta: {
            requiresAuth: true,
            title: '举报',
          },
          component: (resolve) => {
            import('./views/official/report').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/user_assess',
          name: 'user_assess',
          meta: {
            requiresAuth: true,
            title: '评价',
          },
          component: (resolve) => {
            import('./views/official/five_star').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/ban_function',
          name: 'ban_function',
          meta: {
            requiresAuth: true,
            title: '功能封禁记录',
          },
          component: (resolve) => {
            import('./views/official/ban_function').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/money_risk',
          name: 'money_risk',
          meta: {
            requiresAuth: true,
            title: '货币风控',
          },
          component: (resolve) => {
            import('./views/official/money_risk').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/rebind',
          name: 'rebind',
          meta: {
            requiresAuth: true,
            title: '账号换绑',
          },
          component: (resolve) => {
            import('./views/official/rebind').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/safe_strategy',
          name: 'safe_strategy',
          meta: {
            requiresAuth: true,
            title: '安全策略',
          },
          component: (resolve) => {
            import('./views/config/safe_strategy').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/hotchat/game_config',
          name: 'hotchat_game_config',
          meta: {
            requiresAuth: true,
            title: 'Hotchat游戏配置',
          },
          component: (resolve) => {
            import('./views/config/hochat_game_config.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/report/TaskCompleted',
          name: 'xxx',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/host/TaskCompleted').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/statistics/ChatSuccessRateDetail',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/statistics/ChatSuccessRateDetail').then(
              (module) => {
                resolve(module)
              }
            )
          },
        },
        {
          path: '/statistics/ChatDetailReason',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/statistics/ChatDetailReason').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/MatckCardConfig',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/config/MatckCardConfig').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/gift',
          name: '',
          meta: {
            requiresAuth: true,
            title: '礼物管理',
          },
          component: (resolve) => {
            import('./views/config/giftManagement').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/product',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/product').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/goods',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/goods').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/host_open',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/host_open').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/coin_seller',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/coin_management').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/price',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/price').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/currency_detail',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/currency_detail').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/exchange_rate',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/exchange_rate').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/drawPrize',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/drawPrize').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/premiumId',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/premiumId').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/room_items',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/room_items').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/prop',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/prop').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/reward',
          name: 'reward',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/RewardConfig').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/room_background',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/room_background').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/withdraw/partner/mgr',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/withdraw').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/robot/account/mgr',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/robot').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/robot_gift',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/robot_gift').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/whiteList',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/whiteList').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/VestBag',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/VestBag').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/TaskManager',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/TaskManager').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/TemplateTask',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/TemplateTask').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/KeyManage',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/config/KeyManage').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/medal',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/MedalManage').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/room_sticker',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/RoomSticker').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/room_program',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/RoomProgram').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/gift_lucky/config/list',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/lucky_gift').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/user_sign',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/user_sign').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/user_sign_statistic',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/user_sign_statistic').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/game',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/GameConfig/index.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/point/store',
          name: '',
          meta: {
            requiresAuth: true,
            title: 'SVIP积分商城配置',
          },
          component: (resolve) => {
            import('./views/config/point/index.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/auto_message',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/auto_message').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/gear_reward',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/gear_reward').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/match/rule',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/MatchRule/index.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/match/base',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/MatchBase/index.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/theme',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/theme.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/common_test',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/CommonTest.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/migrate_test',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/actor_source.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/recommended_list/rule',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/recommended_list.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/strategy_auto_reply',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/strategy_auto_reply.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/member/benefit',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/benefit.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/method_monitor',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/method_monitor.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/config/train/video',
          name: '',
          meta: {
            requiresAuth: true,
          },
          component: (resolve) => {
            import('./views/config/VideoConfig/index.vue').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/live/action',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/host/action').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/live/liveHostStat',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/host/liveHostStat').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/live/timeBox',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/host/timeBox').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/quality_keep/list',
          name: '',
          meta: {
            requiresAuth: true,
            title: '',
          },
          component: (resolve) => {
            import('./views/host/quality_keep/list').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/monitor/panel',
          name: 'host_monitor_panel',
          meta: {
            requiresAuth: true,
            title: '主播数据监控和预警',
          },
          component: (resolve) => {
            import('./views/host/monitor/panel').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/settlement_detail',
          name: 'settlement_detail',
          meta: {
            requiresAuth: true,
            title: '主播结算',
          },
          component: (resolve) => {
            import('./views/host/settlement_detail').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/host/second/trial_host_pool',
          name: 'trial_host_pool',
          meta: {
            requiresAuth: true,
            title: '',
          },
          component: (resolve) => {
            import('./views/host/second/trial_host_pool').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/retention/userRetention',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/host/userRetention').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/users/online_actors',
          name: '',
          meta: {
            requiresAuth: true,
            title: '用户留存',
          },
          component: (resolve) => {
            import('./views/actormgr/online_actors').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/user/inviteMgr',
          name: '',
          meta: {
            requiresAuth: true,
            title: '邀请绑定',
          },
          component: (resolve) => {
            import('./views/actormgr/inviteMgr').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/match/action',
          name: '',
          meta: {
            requiresAuth: true,
            title: '匹配行为数据',
          },
          component: (resolve) => {
            import('./views/actor/user/action').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/Notice',
          name: '',
          meta: {
            requiresAuth: true,
            title: '官方消息发送',
          },
          component: (resolve) => {
            import('./views/official/notice').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/invite_rebate',
          name: '',
          meta: {
            requiresAuth: true,
            title: '邀请奖励配置',
          },
          component: (resolve) => {
            import('./views/official/invite_rebate').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/invite_lottery',
          name: 'invite_lottery',
          meta: {
            requiresAuth: true,
            title: '邀请拼多多转盘抽奖',
          },
          component: (resolve) => {
            import('./views/official/invite_lottery').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/Generate_Operating',
          name: '',
          meta: {
            requiresAuth: true,
            title: '通用运营位操作',
          },
          component: (resolve) => {
            import('./views/official/operate/index').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/game_lucky/event/list',
          name: '',
          meta: {
            requiresAuth: true,
            title: '弹窗管理',
          },
          component: (resolve) => {
            import('./views/official/lucky_event').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/WeekStar',
          name: '',
          meta: {
            requiresAuth: true,
            title: '周星活动排行榜礼物配置',
          },
          component: (resolve) => {
            import('./views/actor/WeekStar').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/room/config',
          name: '',
          meta: {
            requiresAuth: true,
            title: '房间管理',
          },
          component: (resolve) => {
            import('./views/official/RoomConfig').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/event/model',
          name: '',
          meta: {
            requiresAuth: true,
            title: '活动配置管理',
          },
          component: (resolve) => {
            import('./views/official/ActivityConfig/index').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/feedback/scoreFeedback',
          name: '',
          meta: {
            requiresAuth: true,
            title: '活动模板配置',
          },
          component: (resolve) => {
            import('./views/official/ScoreFeedback').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/starry_config',
          name: '',
          meta: {
            requiresAuth: true,
            title: '心动嘉年华',
          },
          component: (resolve) => {
            import('./views/official/StarryConfig').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/Official/WeekStar/V2',
          name: '',
          meta: {
            requiresAuth: true,
            title: '周星活动(新)',
          },
          component: (resolve) => {
            import('./views/official/WeekStarNew').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/game_room_bill',
          name: 'game_room_bill',
          meta: {
            requiresAuth: true,
            title: '游戏房分成账单',
          },
          component: (resolve) => {
            import('./views/official/game_room_bill').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/offical/game_room_config',
          name: 'game_room_config',
          meta: {
            requiresAuth: true,
            title: '游戏房分成配置',
          },
          component: (resolve) => {
            import('./views/official/game_room_config').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/poolMgr/LuckyGift/V3',
          name: 'poolMgr_LuckyGift_V3',
          meta: {
            requiresAuth: true,
            title: '幸运礼物V3配置管理',
          },
          component: (resolve) => {
            import('./views/Probability/LuckyGiftV3').then((module) => {
              resolve(module)
            })
          },
        },
        {
          path: '/poolMgr/PlayerPool',
          name: 'poolMgr_PlayerPool',
          meta: {
            requiresAuth: true,
            title: '个人奖池调控',
          },
          component: (resolve) => {
            import('./views/Probability/PlayerPool').then((module) => {
              resolve(module)
            })
          },
        },
      ],
    },
  ],
})
